import React from 'react';
import {
  Tabs,
  Tab,
  Paper,
  useTheme,
  useMediaQuery,
  Box,
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  ShowChart,
  Receipt,
  Star as StarIcon,
  AccountBalance as HoldingsIcon,
  Add as ManualTradingIcon,
  Settings as SettingsIcon,
  People as PeopleIcon,
  Assessment as AssessmentIcon,
} from '@mui/icons-material';
import { useAppContext } from '../context/AppContext';

interface DesktopNavigationProps {
  currentTab: number;
  onTabChange: (value: number) => void;
}

const DesktopNavigation: React.FC<DesktopNavigationProps> = ({ currentTab, onTabChange }) => {
  const { state } = useAppContext();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  
  // Check if user is admin
  const isAdmin = state.googleUser?.role === 'admin';

  if (!isDesktop) return null;

  return (
    <Paper sx={{ mb: 2, mx: 3 }}>
      <Box sx={{ px: 2 }}>
        <Tabs
          value={currentTab}
          onChange={(_, newValue) => onTabChange(newValue)}
          sx={{
            '& .MuiTab-root': {
              fontSize: '16px',
              fontWeight: 'bold',
              textTransform: 'none',
              minHeight: '60px',
              '&.Mui-selected': {
                color: '#1565c0',
              },
            },
            '& .MuiTabs-indicator': {
              backgroundColor: '#1565c0',
              height: 3,
            },
          }}
        >
          <Tab
            icon={<DashboardIcon />}
            label="儀表板"
            iconPosition="start"
            sx={{ gap: 1 }}
          />
          <Tab
            icon={<ShowChart />}
            label="股票報價"
            iconPosition="start"
            sx={{ gap: 1 }}
          />
          <Tab
            icon={<StarIcon />}
            label="關注清單"
            iconPosition="start"
            sx={{ gap: 1 }}
          />
          <Tab
            icon={<HoldingsIcon />}
            label="庫存狀況"
            iconPosition="start"
            sx={{ gap: 1 }}
          />
          <Tab
            icon={<Receipt />}
            label="交易紀錄"
            iconPosition="start"
            sx={{ gap: 1 }}
          />
          <Tab
            icon={<ManualTradingIcon />}
            label="手動交易"
            iconPosition="start"
            sx={{ gap: 1 }}
          />
          <Tab
            icon={<AssessmentIcon />}
            label="年度統計"
            iconPosition="start"
            sx={{ gap: 1 }}
          />
          {isAdmin && (
            <Tab
              icon={<SettingsIcon />}
              label="帳戶管理"
              iconPosition="start"
              sx={{ gap: 1 }}
            />
          )}
          {isAdmin && (
            <Tab
              icon={<PeopleIcon />}
              label="用戶管理"
              iconPosition="start"
              sx={{ gap: 1 }}
            />
          )}
        </Tabs>
      </Box>
    </Paper>
  );
};

export default DesktopNavigation;
